/**
 * Settings Service - API client per la gestione delle impostazioni
 */
import { apiFetch } from './apiFetch';

export interface Setting {
  id: number;
  key: string;
  value: Record<string, any>;
  description?: string;
  is_active: boolean;
  created_at: string;
  updated_at: string;
}

export const settingsService = {
  // Get all settings
  async getAllSettings(): Promise<Setting[]> {
    const data = await apiFetch<{ data: Setting[] }>('/settings');
    return data.data || [];
  },

  // Get setting by key
  async getSettingByKey(key: string): Promise<Setting> {
    const data = await apiFetch<{ data: Setting }>(`/settings/${key}`);
    return data.data;
  },

  // Raw API call for custom endpoints
  async raw(method: string, path: string, body?: Record<string, any>): Promise<any> {
    return apiFetch(path, {
      method,
      body: body ? JSON.stringify(body) : undefined,
    });
  },

  // Update setting
  async updateSetting(key: string, value: Record<string, any>): Promise<Setting> {
    const data = await apiFetch<{ data: Setting }>(`/settings/${key}`, {
      method: 'PUT',
      body: JSON.stringify({ value }),
    });
    return data.data;
  },
};

export interface ContactInfo {
  phone: string;
  email: string;
  address: string;
  whatsapp: string;
}

export async function getPublicContact(): Promise<ContactInfo> {
  const data = await apiFetch<{ data: ContactInfo }>('/settings/public/contact');
  return data.data;
}

export interface SiteInfo {
  companyName: string;
  legalAddress: string;
  city: string;
  province: string;
  zip: string;
  region: string;
  vatNumber: string;
  fiscalCode: string;
  reaNumber?: string;
  pec?: string;
  tagline?: string;
}

export async function getPublicSiteInfo(): Promise<SiteInfo | null> {
  const data = await apiFetch<{ data: SiteInfo | null }>('/settings/public/site-info');
  return data.data;
}

export default settingsService;
